<template>
  <Layout title="Register Interest">
    <div class="bg-mountains py-5">
      <div class="container py-5">
        <div class="row py-5">
          <div class="col text-center">
            <h1 class="text-white">Contracting made easy</h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="row">
              <div class="col text-center">
                <div class="embed-responsive embed-responsive-1by1">
                  <div class="embed-responsive-item bg-light rounded-circle p-5 d-flex flex-row">
                    <div class="align-self-center w-100">
                      <Icon icon="Pig" width="80" colour="#6666ff" class="mb-4" />
                      <h5>Save time &amp; money</h5>
                      <p class="mb-0">
                        Our platform works hard so you don't have to.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col text-center">
                <div class="embed-responsive embed-responsive-1by1">
                  <div class="embed-responsive-item bg-light rounded-circle p-5 d-flex flex-row">
                    <div class="align-self-center w-100">
                      <Icon icon="Award" width="69" colour="#6666ff" class="mb-4" />
                      <h5>Industry standard</h5>
                      <p class="mb-0">
                        Start with a certified, industry standard contract.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col text-center">
                <div class="embed-responsive embed-responsive-1by1">
                  <div class="embed-responsive-item bg-light rounded-circle p-5 d-flex flex-row">
                    <div class="align-self-center w-100">
                      <Icon icon="Fingerprint" width="52" colour="#6666ff" class="mb-4" />
                      <h5>Secure sign</h5>
                      <p class="mb-0">
                        Use digital signiture to sign contracts.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 text-center">
          <h1 class="mt-5">Register Interest</h1>
        </div>
        <div class="col-md-6 text-center">
          <p>
            Interested in Clausify? Leave us your details and we'll contact you within 48 hours to discuss how Clausify could help your organisation.
          </p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-6">
          <form v-if="!success" method="POST" @submit.prevent="submit">
            <div class="form-group">
              <TextInput
                v-model="form.name"
                :errors="$page.props.errors.name"
                label="Your Name"
                autofocus
                autocapitalize="off"
                validateSuccess
                validateError
              />
            </div>
            <div class="form-group">
              <TextInput
                v-model="form.organisation"
                :errors="$page.props.errors.organisation"
                label="Your organisation's name"
                validateSuccess
                validateError
              />
            </div>
            <div class="form-group">
              <TextInput
                v-model="form.email"
                :errors="$page.props.errors.email"
                type="email"
                label="Your business email address"
                autocomplete="email"
                validateSuccess
                validateError
              />
            </div>
            <div class="form-group">
              <Textarea
                v-model="form.message"
                :errors="$page.props.errors.message"
                label="Your message"
                rows="5"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <div class="col-md-4 offset-md-4">
                <LoadingButton
                  :loading="sending"
                  type="submit"
                  class="btn btn-primary btn-block"
                >
                  Send Message
                </LoadingButton>
              </div>
            </div>
          </form>

          <div v-else class="my-5">
            <div
              class="flex-column
                p-5
                d-flex
                align-items-center
                justify-content-center
                bg-light
                border
                text-center"
            >
              <Icon
                icon="send"
                :width="100"
                colour="#e1e8fa"
                class="mb-5"
              />
              <p class="mb-0">
                Thank you for contacting us. Your message has been sent! Look out for a response from us within 48 hours.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import TextInput from '@/Shared/Inputs/Text';
import Textarea from '@/Shared/Inputs/Textarea';
import LoadingButton from '@/Shared/LoadingButton';
import Icon from '@/Icons/Icon';

export default {
  components: {
    Layout,
    Textarea,
    TextInput,
    LoadingButton,
    Icon,
  },

  props: {
    success: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: this.$inertia.form({
        name: '',
        organisation: '',
        email: '',
        message: '',
      }),
      sending: false,
    };
  },

  methods: {
    submit() {
      this.sending = true;

      this.form.post(this.route('register-interest.store'), {
        preserveScroll: true,
        onSuccess: () => {
          this.sending = false;
        },
      });
    },
  },
};
</script>
